import { russianDefaultPaymentCards } from "app/constants/CurrencyConstants";

export const reducer: typeof window.kinosite.reducer = {
	cinema: {
		payment: {
			active: true,
			card: russianDefaultPaymentCards,
		},
		selectButton: {
			options: [{
				value: 'https://polyus.cinema-grad.com',
				title: 'ТРК «Южный Полюс»',
			},
			{
				value: 'https://nahodka.cinema-grad.com',
				title: 'ТРК «Порт Находка»',
			},
			{
				value: 'https://vidnoe.cinema-grad.com',
				title: 'Видное',
			}],
			selectedOptionValue: 'https://polyus.cinema-grad.com',
		},
		soonPageIsEnabled: false,
	},
	feedback: true,
};
